<template>
    <div>
        <BTable striped :items="subscribes" :fields="fields"  responsive="sm"></BTable>
    </div>
</template>

<script>


import {
    BTable,
} from 'bootstrap-vue-next';
export default {
    name: "tender_users",
    emits : ['changeAtr'],
    
    components : {
        BTable
    },
    
    props : {
        tender : {
            type : Object
        }
    },
    
    data() {
        return {
            fields: [
                {
                    key: 'contact_name',
                    label: "ПІБ",
                    sortable: true
                },
                {
                    key: 'company',
                    label: "Організація",
                    sortable: true
                },
                {
                    key: 'email',
                    
                    sortable: true
                },
                {
                    key: 'contact_tel',
                    label: "Телефон",
                    sortable: true
                }],
        }
    },
    
    computed : {
        subscribes () {
            return  this.tender.subscribes;
        }
    }
    
}
</script>

<style scoped>

</style>